export const ActionTypeEnum = {
  COPY: 'copy',
  DELETE: 'delete',
  EDIT: 'edit',
};
